import { render, staticRenderFns } from "./deanSectionTitleRemoveRestore.vue?vue&type=template&id=25fb9740&scoped=true"
import script from "./deanSectionTitleRemoveRestore.vue?vue&type=script&lang=ts"
export * from "./deanSectionTitleRemoveRestore.vue?vue&type=script&lang=ts"
import style0 from "./deanSectionTitleRemoveRestore.vue?vue&type=style&index=0&id=25fb9740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb9740",
  null
  
)

export default component.exports